import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Settings } from '../../app.settings.model';
import { AppSettings } from '../../app.settings';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-circular-menu',
  templateUrl: './circular-menu.component.html',
  styleUrls: ['./circular-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CircularMenuComponent implements OnInit {
  circularList: any = {
    label: 'Options',
    isOpen: false,
    menu: [
      {
        id: 0,
        label: 'Print',
        icon: 'mdi-printer',
        iconPath: null,
        iconPathHover: null,
        isHover: false
      },
      {
        id: 1,
        label: 'PDF',
        icon: null,
        iconPath: 'Icons/pdfWhite.png',
        iconPathHover: 'Icons/pdfBlack.png',
        isHover: false
      },
      {
        id: 2,
        label: 'Excel',
        icon: null,
        iconPath: 'Icons/ExcelWhite.png',
        iconPathHover: 'Icons/ExcelBlack.png',
        isHover: false
      },
      {
        id: 3,
        label: 'CSV',
        icon: null,
        iconPath: 'Icons/csvWhite.png',
        iconPathHover: 'Icons/csvBlack.png',
        isHover: false
      }
    ]
  };

  public settings: Settings;

  constructor(
    public appSettings: AppSettings,
    public translate: TranslateService,
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {}

  onClickedOutside(e: any): void {
    this.circularList.isOpen = false;
  }

  action(index: number): void {
    if (this.circularList != null) {
      this.circularList.menu[index].isHover = false;
    }
  }

  trackBy(item: any): number {
    return item.id;
  }
}
